import { render, staticRenderFns } from "./readonly-editor.vue?vue&type=template&id=84efb8ea&scoped=true"
import script from "./readonly-editor.vue?vue&type=script&lang=js"
export * from "./readonly-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84efb8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84efb8ea')) {
      api.createRecord('84efb8ea', component.options)
    } else {
      api.reload('84efb8ea', component.options)
    }
    module.hot.accept("./readonly-editor.vue?vue&type=template&id=84efb8ea&scoped=true", function () {
      api.rerender('84efb8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/readonly-editor.vue"
export default component.exports